module.exports = __webpack_public_path__ + "static/media/thomas-tucker-au3CYbd7vCU-unsplash.491ff013.webp";